import { useEffect, useState } from 'react';
import Lookup from 'src/componentes/select-async';
import ConsequenciaRiscoEdit from '../paginas/gestao-risco/consequencias/edit';
import ConsequenciaRiscoList from '../paginas/gestao-risco/consequencias';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

const ConsequenciaRisco = (props) => {
  const endpoint = '/ConsequenciaRiscoLookup';
  const [podeEditar, setPodeEditar] = useState(false);

  const ObterPermissao = async () => {
    try {
      const response = await http.get(`${endpoint}/ObterPermissaoEditar`);
      setPodeEditar(response?.data);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    ObterPermissao();
  }, []);

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url={endpoint}
      editComponent={podeEditar ? ConsequenciaRiscoEdit : null}
      searchComponent={ConsequenciaRiscoList}
      showSearch
      clearable={true}
      useClickToOpen={false}
      {...props}
    />
  );
};

export default ConsequenciaRisco;
